function GoldDivider() {
  return (
    <div className="relative mx-auto my-2 h-px w-full max-w-7xl overflow-hidden px-4" aria-hidden="true">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-amber-500/60 to-transparent" />
      <div className="absolute inset-0 h-px w-1/3 animate-[shimmer_3.5s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-amber-300 to-transparent" />
      <style>
        {`
          @keyframes shimmer {
            0% { transform: translateX(-100%); opacity: 0; }
            50% { opacity: 1; }
            100% { transform: translateX(300%); opacity: 0; }
          }
        `}
      </style>
    </div>
  )
}

export default GoldDivider
